import { toBigWithDefault, type OptionalProperties } from '../utils';
import {
  SubAccountReconCheckpointStatusEnum,
  type IABORReconCheckpoint,
  type IABORReconCheckpoint4692Comments,
  type IABORReconCheckpoint4692ReconMarketAccounts,
  type IABORReconCheckpoint4692ReconSubAccounts,
} from './types';

/** Frontend model for ABORReconCheckpoint websocket messages. */
export type ABORReconCheckpoint = OptionalProperties<IABORReconCheckpoint, 'Comments'>;

export type ABORReconCheckpointComment = IABORReconCheckpoint4692Comments;
export type ABORReconCheckpointSubAccount = IABORReconCheckpoint4692ReconSubAccounts;
export type ABORReconCheckpointMarketAccount = IABORReconCheckpoint4692ReconMarketAccounts;

export function aborReconCheckpointHasBreak(checkpoint: ABORReconCheckpoint): boolean {
  if (checkpoint.Status === SubAccountReconCheckpointStatusEnum.Discarded) {
    return false;
  }

  if (checkpoint.Status !== SubAccountReconCheckpointStatusEnum.Reconciled) {
    return true;
  }

  if (!toBigWithDefault(checkpoint.UnmatchedAmount, 0).eq(0)) {
    return true;
  }

  if (!toBigWithDefault(checkpoint.EquivalentUnmatchedAmount, 0).eq(0)) {
    return true;
  }

  return false;
}
